import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";

type Props = {
    /**
     * If true, the buttons will not be shown in the UI. Used in conjunction with OwAcceptCancelActions
     */
    isEditMode: boolean;
    withLabels?: boolean;
    className?: string;
    hideTrash?: boolean;
    hideEdit?: boolean;
    onTrashClickFn?: (e: any) => void;
    onEditClickFn?: (e: any) => void;
};

export const OwDeleteEditActions = (props: Props) => {
    return (
        <div className={"OwDeleteEditActions " + props.className || ""}>
            {!props.isEditMode ? (
                <div>
                    <ButtonGroup>
                        {props.hideTrash ? null : (
                            <Button
                                variant={"danger"}
                                size={"sm"}
                                onClick={
                                    props.onTrashClickFn ||
                                    (() => {
                                        console.log("Implement onTrashClickFn");
                                    })
                                }>
                                <i className={"fas fa-trash-alt"}></i>
                                {props.withLabels ? " Delete" : ""}
                            </Button>
                        )}
                        {props.hideEdit ? null : (
                            <Button
                                size={"sm"}
                                className={"btn-primary"}
                                onClick={
                                    props.onEditClickFn ||
                                    (() => {
                                        console.log("Implement onEditClickFn");
                                    })
                                }>
                                <i className={"fas fa-pencil"}></i>
                                {props.withLabels ? " Edit" : ""}
                            </Button>
                        )}
                    </ButtonGroup>
                </div>
            ) : null}
        </div>
    );
};
